import React from 'react'
import PropTypes from 'prop-types'

import { Button, Typography } from '@chilecompra/react-kit/components'

import { ContainerCheck, Grid, MainCircle, StyledCheckIcon } from './SelectOfferDialog.styles'

import { REACT_APP_MERCADO_PUBLICO_BASE_URL } from '../../config/settings/environment'
import { PURCHASE_ORDER_ISSUE_URL } from '../../config/settings/constants'

/**
 * The SelectOfferSuccess's.
 */
const SelectOfferSuccess = props => {
  const { onClose, purchaseInfo } = props

  const handleCloseDialog = () => onClose()
  const handleNextDialog = () => {
    window.location.href = REACT_APP_MERCADO_PUBLICO_BASE_URL.concat(PURCHASE_ORDER_ISSUE_URL).concat(
      purchaseInfo?.purchaseId
    )
  }

  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item textAlign="center" padding="13px">
        <ContainerCheck style={{ display: 'flex', justifyContent: 'center' }} margin="0 0 18px">
          <MainCircle backgroundColor="success">
            <StyledCheckIcon />
          </MainCircle>
        </ContainerCheck>
        <Typography fontWeight="bold" variant="h3" tabIndex="0">
          Orden de compra generada
        </Typography>
      </Grid>
      <Grid item textAlign="center">
        <Typography variant="body1" tabIndex="0">
          Número ID de orden de compra
        </Typography>
        <Typography fontWeight="bold" variant="h2" color="success" tabIndex="0">
          {purchaseInfo?.purchaseCode}
        </Typography>
      </Grid>
      <Grid item padding="32px 0 0" margin="4px 0" textAlign="center">
        <Button
          aria-label="Continuar edición de la orden de compra"
          color="success"
          variant="contained"
          onClick={handleNextDialog}
        >
          Continuar edición de la orden de compra
        </Button>
      </Grid>
      <Grid item padding="0 0 28px" margin="4px 0" textAlign="center">
        <Button aria-label="Volver a la ficha de Compra Ágil" variant="text" onClick={handleCloseDialog}>
          Volver a la ficha de Compra Ágil
        </Button>
      </Grid>
    </Grid>
  )
}

SelectOfferSuccess.propTypes = {
  onClose: PropTypes.func,
  purchaseInfo: PropTypes.shape({
    purchaseId: PropTypes.string,
    purchaseCode: PropTypes.string,
    purchaseUrl: PropTypes.string
  })
}

export default SelectOfferSuccess
